<div class="offCanvas__container">
  <div class="offCanvas__contentWrapper">
    <div class="offCanvas__header">
      <div class="offCanvas__title">
        {{ editItem ? 'Edit Metadata Field' : 'Add Metadata Field' }}
      </div>
      <img (click)="onCloseIconClick(false)" class="offCanvas__crossIcon"
        src="../../../assets/Images/organisation-structure/Cross.svg" alt="cross icon" />
      </div>
      <form class="mt-3" [formGroup]="lookupFormGroup">
        <div class="offcanvas__content">
          <div class="offcanvas__orgDetails">
            <div class="offCanvas__orgName-inputField">
              <app-input-filed label="Label" placeholder="Enter label"
                [control]="$any(lookupFormGroup).controls['label']" [value]="editItem?.label"
              [starIcon]="'*'"></app-input-filed>
            </div>
            @if (lookupFormGroup.get('label')?.value) {
              <div class="addUser__dropdown">
                <div class="addUser__dropdownLabel">
                  Select Type<span class="star">*</span>
                </div>
                <select class="addUser__dropdownOptions" (change)="onChange($event)" formControlName="fieldType"
                  [disabled]="!!editItem?._id">
                  <option value="" disabled selected>Please select type</option>
                  @for (item of selectType; track item) {
                    <option [disabled]="editItem?._id" [value]="item"
                      [selected]="item === editItem?.fieldType">
                      {{ item }}
                    </option>
                  }
                </select>
              </div>
            }
            @if (showOptions) {
              <span class="label mt-3">Enter Options</span>
              <div class="customInput">
                <input class="inputfield" placeholder="Enter option" formControlName="metadata">
                <button type="button" (click)="addData()" class="btn btn-secondary button-custom-styles"
                  [disabled]="isDuplicateField()">
                  <fa-icon [icon]="faPlus"></fa-icon>
                </button>
              </div>
              @if (isDuplicateField()) {
                <small class="text-danger">Duplicate options are not allowed</small>
              }
              <div class="data">
                @for (field of addedFields; track field) {
                  <button class="btn btn-custom">{{field}}<button
                    type="button" class="btn-close" aria-label="close"
                  (click)="deleteFieldValues(field)"></button></button>
                }
              </div>
            }
          </div>
          @if (lookupFormGroup.get('label')?.value) {
            <div class="checkBox">
              <input type="checkbox" (change)="isChecked($event)" formControlName="validateRequire"
                [checked]="editItem?.validateRequire"> Required
              </div>
            }

            @if (entityType === 'medical') {
              <div class="mt-4">
                <app-text-area [label]="'Custom Prompt'" [placeholder]="'Enter custom prompt to generate results'"></app-text-area>
              </div>
            }
            @if (errorMessage) {
              <small class="text-danger">{{ errorMessage }}</small>
            }
          </div>
        </form>
      </div>
      <div class="offCanvas__footer">
        <app-common-button (clickEvent)="onCloseIconClick(false)" buttonClass="smallbutton"
        buttonLabel="Cancel"></app-common-button>
        @if (commonService.orgLock()) {
          <app-common-button (clickEvent)="onSubmit()" [loadingIcon]="verifyLoader"
            buttonClass="smallFilledButton" [buttonLabel]="editItem ? 'Update' : 'Save'"
          [disabled]="lookupFormGroup.invalid || (showOptions && !addedFields.length)"></app-common-button>
        }
      </div>
    </div>